import React from 'react'
import Main from '../layouts/Main'
import EditProfile from '../components/EditProfile'

function Profile() {
    return (
        <Main>
            <div className="d-flex align-items-center justify-content-between my-4 page-header-breadcrumb flex-wrap gap-2">
                <div>
                    <p className="fw-semibold fs-20 mb-0">Edit Profile</p>
                </div>
            </div>
            <EditProfile />
        </Main>
    )
}

export default Profile